import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useDebounce } from 'use-debounce';

import logo from '../images/logo_text.png';
import ChildPage from '../child/ChildPage';
import { useLocation, useNavigate } from 'react-router-dom';
import DropdownContainer from '../dropdown/Dropdown';
import { Form } from 'react-bootstrap';
import './SearchChild.css';
import moment from 'moment';
import check from '../images/check.png';
import absent from '../images/semnx.png';
import WarnIconRed from '../images/warn-red.png';
import WarnIconYellow from '../images/warn-yellow.png';
import IconCheck from '../images/check.png';
import IconCancel from '../images/semnx.png';
import IconTransfer from '../images/transfer.png';
import PrezentaInfirm from '../images/prezentamitzuuinfirm.png';
import PrezentaConfirm from '../images/prezentamitzuuconfirm.png';
import { isDateLessThan30DaysAgo } from '../../utils/utils';
import InfiniteScroll from "react-infinite-scroll-component";
import Level1 from '../images/Untitled-2.png';
import Level2 from '../images/Untitled-3.png';
import Level3 from '../images/Untitled-4.png';
import Level4 from '../images/Untitled-5.png';
import Level5 from '../images/Untitled-6.png';
import Level6 from '../images/Untitled-7.png';
import Level7 from '../images/Untitled-8.png';

import centuraIcon from '../images/centura.png';
import { splitGroupAndTimes } from '../../utils/utils';



function SearchChild() {
  const location = useLocation();

  const [scrollPosition, setScrollPosition] = useState(0);
  const navigate = useNavigate();
  const admin = window.localStorage.getItem("token") != null;
  const token = window.localStorage.getItem("token");
  let userType = window.localStorage.getItem("userType");

  // Filters
  // Search input state with debounce
  const [searchInput, setSearchInput] = useState(location.state ? location.state.search || '' : '');
  const [debouncedSearchInput] = useDebounce(searchInput, 300); // Adjust the debounce delay as needed
  const searchInputRef = useRef("");    // Aici e valoare finala din search bar

  const [attendeeLocation, setAttendeeLocation] = useState(userType === "OWNER" ? window.localStorage.getItem("location") || '' : ''); // Location filter, default to user's location if OWNER
  const [group, setGroup] = useState(window.localStorage.getItem("group") || ''); // Selected group
  const [time, setTime] = useState(window.localStorage.getItem("time") || ''); // Selected time

  const [showValid, setShowValid] = useState(window.localStorage.getItem("showValid") ? JSON.parse(window.localStorage.getItem("showValid")) : true); // Show valid children by default
  const [showHidden, setShowHidden] = useState(window.localStorage.getItem("showHidden") ? JSON.parse(window.localStorage.getItem("showHidden")) : false); // Show hidden children by default
  const [showInvalid, setShowInvalid] = useState(window.localStorage.getItem("showInvalid") ? JSON.parse(window.localStorage.getItem("showInvalid")) : false); // Show invalid children by default
  const [showUnhidden, setShowUnhidden] = useState(window.localStorage.getItem("showUnhidden") ? JSON.parse(window.localStorage.getItem("showUnhidden")) : true); // Show unhidden children by default

  const [nextCursor, setNextCursor] = useState(null);

  const [validatedAttendeesCount, setValidatedAttendeesCount] = useState(0);
  const [presentChildrenCount, setPresentChildrenCount] = useState(0);

  const [children, setChildren] = useState([]);
  const [selectedChild, setSelectedChild] = useState({});
  const [selectedChildId, setSelectedChildId] = useState(null);
  const [userLocation, setUserLocation] = useState('');

  const [anyTbdChildren, setAnyTbdChildren] = useState(false);

  // Add loading state for filter changes
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  useEffect(() => {
    const savedSelectedChildId = window.localStorage.getItem("selectedChildId");
    if (savedSelectedChildId) {
      setSelectedChildId(savedSelectedChildId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedChildId) {
      // Fetch the selected child data if an ID is stored
      axios.get(process.env.REACT_APP_API_URL + `/attendees/${selectedChildId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).then(res => {
        setSelectedChild(res.data);
      }).catch(err => {
        console.error("Error fetching selected child data:", err);
      });
    }
  }, [selectedChildId]);

  useEffect(() => {
    // Set the search input value to the debounced value
    searchInputRef.current = debouncedSearchInput;

    // Set loading to true when filters change
    setIsFilterLoading(true);

    // Fetch data and then set loading to false
    const fetchData = async () => {
      await Promise.all([
        fetchChildrenData(),
        fetchIsAnyTbdChildren(),
        fetchValidatedAttendeesCount(),
        fetchPresentChildrenCount()
      ]);
      setIsFilterLoading(false);
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchInput, attendeeLocation, group, time, showValid, showHidden, showInvalid, showUnhidden]);


  useEffect(() => {
    if (!admin)
      navigate('/');
    if (location.state != null && location.state.search != null) {
      location.state.search = null
    }

    let userLoc = "";
    if (admin && !userType)
      axios.get(process.env.REACT_APP_API_URL + "/auth/type", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((res) => {
        window.localStorage.setItem("userType", res.data.userType);
        window.localStorage.setItem("userLoc", res.data.location);
        userType = res.data.userType;
        setUserLocation(res.data.location);
        userLoc = res.data.location;
      }).catch((err) => {
      });
    else if (admin && userType) {
      setUserLocation(window.localStorage.getItem("userLoc"));
    }
    if (window.localStorage.getItem("scrollPosition")) {
      setScrollPosition(window.localStorage.getItem("scrollPosition"));
    }

  }, [debouncedSearchInput, JSON.stringify(selectedChild)]);

  // Fetch functions
  const fetchChildrenData = async () => {
    try {
      console.log("Fetching children data");
      const response = await axios.get(process.env.REACT_APP_API_URL + "/attendees/all/admin", {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params: {
          search: debouncedSearchInput,
          location: attendeeLocation.toUpperCase(),
          group: group,
          time: time,
          showValid: showValid,
          showHidden: showHidden,
          showInvalid: showInvalid,
          showUnhidden: showUnhidden,
          pageSize: 30
        }
      });

      setChildren(response.data.attendees);
      setNextCursor(response.data.nextCursor);
    } catch (error) {
      console.error("Error fetching children data:", error);
      // Handle error appropriately, e.g., show a notification or alert
    }
  }

  const fetchNextChildrenData = async () => {
    try {
      axios.get(process.env.REACT_APP_API_URL + "/attendees/all/admin", {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params: {
          search: debouncedSearchInput,
          location: attendeeLocation.toUpperCase(),
          group: group,
          time: time,
          showValid: showValid,
          showHidden: showHidden,
          showInvalid: showInvalid,
          showUnhidden: showUnhidden,
          nextCursor: nextCursor,
          pageSize: 30, // Set the page size to 30
        }
      }).then(res => {
        setChildren(prevChildren => [...prevChildren, ...res.data.attendees]);
        setNextCursor(res.data.nextCursor);
      });
    } catch (error) {
      console.error("Error fetching next children data:", error);
      // Handle error appropriately, e.g., show a notification or alert
    }
  }

  const fetchIsAnyTbdChildren = async () => {
    try {
      console.log("Fetching if there are any TBD children");
      axios.get(process.env.REACT_APP_API_URL + "/attendees/tbd/any", {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).then((res) => {
        setAnyTbdChildren(res.data);
      }).catch((error) => {
        console.log(error);
      });
    } catch (error) {
      console.error("Error fetching if there are any TBD children:", error);
      // Handle error appropriately, e.g., show a notification or alert
    }
  }

  const fetchValidatedAttendeesCount = async () => {
    try {
      axios.get(process.env.REACT_APP_API_URL + "/attendees/count/validated", {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          location: attendeeLocation.toUpperCase(),
        }
      }).then((response) => {
        setValidatedAttendeesCount(response.data.attendeesCount);
      }
      ).catch((error) => {
        console.error("Error fetching validated attendees count:", error);
      });
    } catch (error) {
      console.error("Error fetching validated attendees count:", error);
      // Handle error appropriately, e.g., show a notification or alert
    }
  }

  const fetchPresentChildrenCount = async () => {
    try {
      console.log("Fetching present children count");
      axios.get(process.env.REACT_APP_API_URL + "/attendees/count/presence/today", {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          location: attendeeLocation.toUpperCase(),
          group: group,
          time: time,
        }
      }).then((response) => {
        setPresentChildrenCount(response.data.attendeesCount);
      }
      ).catch((error) => {
        console.error("Error fetching present children count:", error);
      });
    } catch (error) {
      console.error("Error fetching present children count:", error);
      // Handle error appropriately, e.g., show a notification or alert
    }
  }

  function getClassByMembership(membership) {
    if (membership === 'GRUPA') {
      return "aqua";
    } else if (membership === 'PT') {
      return "violet";
    } else if (membership === 'MINI-GRUPA') {
      return "chartreuse";
    } else if (membership === 'GRATIS') {
      return "orange";
    }
    return "white";
  }

  function handleClose() {
    setSelectedChild({});
    setSelectedChildId(null);
    window.localStorage.removeItem("selectedChildId");
    if (window.localStorage.getItem("goRanking") == "1") {
      window.localStorage.removeItem("goRanking");
      window.localStorage.setItem("LBLoc", "Otopeni");
      navigate("/");
    } else if (window.localStorage.getItem("goRanking") == "2") {
      window.localStorage.removeItem("goRanking");
      window.localStorage.setItem("LBLoc", "Dobroesti");
      navigate("/");
    }
    setTimeout(function () {
      window.scrollTo(0, scrollPosition);
    }, 2);
    window.localStorage.removeItem("scrollPosition");

    // Fetch presences
    fetchPresentChildrenCount();
  }

  const handleDropdownChange = (field, selectedOption) => {
    // Set loading immediately when filter changes
    setIsFilterLoading(true);

    if (selectedOption !== '') {
      setShowUnhidden(true);
      setShowHidden(false);
      window.localStorage.setItem("showUnhidden", true);
      window.localStorage.setItem("showHidden", false);
    }
    if (field === 'day') {
      setGroup(selectedOption);
      window.localStorage.setItem("group", selectedOption);
    } else if (field === 'time') {
      console.log("Selected time: " + selectedOption);
      setTime(selectedOption);
      window.localStorage.setItem("time", selectedOption);
    } else if (field === 'location') {
      console.log("Selected location: " + selectedOption);
      setAttendeeLocation(selectedOption);
      window.localStorage.setItem("location", selectedOption);
    }
  };

  function rescheduleEffect(child, option) {
    //optiunea 1 pt striketrough text si optiunea 2 pt border animat
    if (child.reschedule == "" || child.rescheduleDate == null) return '';
    let reArray = child.reschedule.split("-");
    let firstDay = reArray[0].split(",");
    let secondDay = reArray[1].split(",");
    //let datacopil = new Date(child.rescheduleDate).setHours(6);
    //daca ce e selectat in dropdown e aceiasi cu grupa lui din reprogramare e taiat
    //daca ce e selectat in dropwdown este ce e in a doua parte a reprogramarii e animat
    //cazul cand grupa lui e aceiasi cu grupa reprogramata Ex: Ma - Ma
    let groupsChild = child.group.split('-');
    let timesChild = child.time.split('-');
    if (timesChild.length < groupsChild.length)
      for (let i = timesChild.length; i < groupsChild.length; i++) //de vazut
        timesChild.push(timesChild[0]);
    //if (new Date(child.rescheduleDate).toDateString() !== new Date().toDateString() && groupsChild.includes(group) && timesChild.includes(time)) {
    if (new Date(child.rescheduleDate).toDateString() !== new Date().toDateString()) {
      if (option === 1) {
        return "line-through";
      } else {
        return '';
      }
    } else if (group == secondDay[0] && time == secondDay[1]) {
      if (option === 1) {
        return "none";
      } else {
        if (child.rescheduleDate != null && new Date(child.rescheduleDate).toDateString() == new Date().toDateString())
          return 'pulsating-borderzero border-success border';

      }
    }
    /*if (option === 1 && new Date(child.rescheduleDate).toDateString() != new Date().toDateString()) {
      return "line-through";
    } else {
      if (child.rescheduleDate != null && new Date(child.rescheduleDate).toDateString() == new Date().toDateString())
        return 'pulsating-borderzero border-success';
    }
    if(option === 1) {
      //console.log("nu aici");
      return "none";
    } else {
      return '';
    }
    }*/
  }

  /**
   * Handles the update of the selected child's data.
   */
  async function handleUpdate() {
    console.log("Updating children data");
    let id = selectedChild._id;

    await axios.get(process.env.REACT_APP_API_URL + `/attendees/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).then(async (res) => {
      // Update the selected child with the new data
      setSelectedChild(res.data);

      // Update the children list with the new data
      setChildren((prevChildren) => {
        return prevChildren.map((child) => {
          if (child._id === id) {
            return res.data; // Replace the old child with the updated one
          }
          return child; // Keep the other children unchanged
        });
      });
    });
  }

  const handleChildPageButtonClick = () => {
    setScrollPosition(window.scrollY);
    window.localStorage.setItem("scrollPosition", window.scrollY);
  };

  // Return how many days ago was the first attendance or 0 if there is no attendance
  const childFirstAttendance = (child) => {
    // Get first present attendance
    const firstAttendance = child.attendance.find((att) => att.status === 'PRESENT');

    // If there is no attendance, return 0
    if (!firstAttendance) {
      return 0;
    }

    // Calculate how many days ago was the first attendance
    const today = new Date();
    const firstAttendanceDate = new Date(firstAttendance.date);
    const diffTime = Math.abs(today - firstAttendanceDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  function checkGiftEqualRank(rank, currentGift) {
    return rank > currentGift + 1;

  }

  function getGiftImage(giftGiven) {
    const giftImages = [Level1, Level2, Level3, Level4, Level5, Level6, Level7];
    // Return the next gift image (giftGiven is the last received gift, so we show the next one)
    return giftImages[giftGiven];
  }

  const isTbdChild = (child) => {
    return (child.membership === 'GRATIS' && child.validated === false && !child.hidden && (child.group === 'TBD' || child.time === 'TBD'));
  }

  return (
    <div className="page no-padding-top">
      {JSON.stringify(selectedChild) === '{}' ? (
        <>
          <div className="mx-md-5 py-3 text-md-start">
            <a href="/">
              <img src={logo} className="logo-search" alt="Logo" />
            </a>
          </div>
          <Row className="m-0">
            <Col lg={4} md={6} className="">
              <form onSubmit={(e) => { e.preventDefault(); }}>
                <input
                  type="text"
                  value={searchInput}
                  onChange={(val) => {
                    setIsFilterLoading(true);
                    setSearchInput(val.target.value);
                  }}
                  className="search-bar"
                />
                <p>{/* ... */}</p>
              </form>
              <div>
                <DropdownContainer onChange={handleDropdownChange} defaultDay={group} defaultTime={time} defaultLocation={attendeeLocation} role={userType} />
                <Form className='w-100 mb-4 m-auto text-center'>
                  <Row className='justify-content-around'>
                    <Col xs={7} sm={5} md={7} lg={10} xl={8} xxl={5}>
                      <Form.Check
                        type="checkbox"
                        id='default-checkbox1'
                        label={
                          <span className='fst-italic text-warning'>
                            Doar validați
                          </span>
                        }
                        defaultChecked={showValid}
                        className="my-4 m-auto text-break text-end text-light"
                        onChange={(e) => {
                          setIsFilterLoading(true);
                          setShowValid(e.target.checked);
                          window.localStorage.setItem("showValid", e.target.checked);
                        }}
                      />
                    </Col>
                    {userType !== "COACH" && (
                      <Col xs={7} sm={5} md={7} lg={10} xl={8} xxl={5}>
                        <Form.Check
                          type="checkbox"
                          id='default-checkbox2'
                          label={
                            <span className='fst-italic text-warning'>
                              Doar ascunși
                            </span>
                          }
                          checked={showHidden}
                          defaultChecked={showHidden}
                          className="my-4 m-auto text-break text-end text-light"
                          onChange={(e) => {
                            setIsFilterLoading(true);
                            setShowHidden(e.target.checked);
                            window.localStorage.setItem("showHidden", e.target.checked);
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                  <Row className='justify-content-around'>
                    <Col xs={7} sm={5} md={7} lg={10} xl={8} xxl={5}>
                      <Form.Check
                        type="checkbox"
                        id='default-checkbox3'
                        label={
                          <span className='fst-italic text-warning position-relative'>
                            Doar Nevalidați
                            {anyTbdChildren && (
                              <img
                                src={WarnIconRed}
                                alt="warning"
                                className="warning-icon position-absolute ms-1 pulsating-warning"
                                style={{ width: "20px", height: "20px", }}
                              />
                            )}
                          </span>
                        }
                        defaultChecked={showInvalid}
                        className="my-4 m-auto text-break text-end text-light"
                        onChange={(e) => {
                          setIsFilterLoading(true);
                          setShowInvalid(e.target.checked);
                          window.localStorage.setItem("showInvalid", e.target.checked);
                        }}
                      />
                    </Col>
                    {userType !== "COACH" && (
                      <Col xs={7} sm={5} md={7} lg={10} xl={8} xxl={5}>
                        <Form.Check
                          type="checkbox"
                          id='default-checkbox4'
                          label={
                            <span className='fst-italic text-warning'>
                              Doar Neascunși
                            </span>
                          }
                          checked={showUnhidden}
                          defaultChecked={showUnhidden}
                          className="my-4 m-auto text-break text-end text-light"
                          onChange={(e) => {
                            setIsFilterLoading(true);
                            setShowUnhidden(e.target.checked);
                            window.localStorage.setItem("showUnhidden", e.target.checked);
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col xs={7} sm={5} md={7} lg={10} xl={8} xxl={5}>
                      <span className='fst-italic text-warning'>
                        Numarul de copii: {validatedAttendeesCount}
                      </span>
                    </Col>
                    <Col xs={7} sm={5} md={7} lg={10} xl={8} xxl={5}>
                      <span className='fst-italic text-white'>
                        Copii prezenti:
                      </span>
                      &nbsp;
                      <span className='fst-italic text-success'>
                        {presentChildrenCount}
                      </span>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
            <Col lg={8} md={6}>
              <h1 className="text-break mt-md-4 mb-4 fw-bold fst-italic">
                Lista copiilor înscriși la TRY Academy
              </h1>

              {/* Loading overlay */}
              {isFilterLoading && (
                <div className="d-flex justify-content-center align-items-center mb-4">
                  <div className="spinner-border text-primary me-3" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <h5 className="text-white mb-0">Se încarcă copiii...</h5>
                </div>
              )}

              <div style={{ opacity: isFilterLoading ? 0.5 : 1, transition: 'opacity 0.3s ease' }}>
                <InfiniteScroll
                  style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
                  dataLength={children.length}
                  next={fetchNextChildrenData}
                  hasMore={nextCursor !== null && !isFilterLoading}
                  loader={<h4 className='text-white'>Încărcare...</h4>}
                >
                  {children.map((child, index) => (
                    <button
                      key={index}
                      disabled={isFilterLoading}
                      className={`border-4 rounded-5 mx-2 my-2 child-container d-flex align-items-center justify-content-center ${child.hidden ? 'hidden' : ''}
                            ${(child.rescheduleDate && (child.paymentStatus === 'PARTIAL' || (child.paymentStatus === 'TBD' && child.validated === true))) ? 'border-HalfStyle' :
                          (child.rescheduleDate && child.attendanceNo === 1) ? 'pulsating-border-JumiUlt' :
                            (child.rescheduleDate && child.attendanceNo === 0) ? 'pulsating-border-JumiZero' :
                              ((child.paymentStatus === 'PARTIAL' || (child.paymentStatus === 'TBD' && child.validated === true)) && child.attendanceNo !== 0) ? 'pulsating-border-alabala border-dottedP' :
                                ((child.paymentStatus === 'PARTIAL' || child.paymentStatus === 'TBD') && (child.membership !== 'GRATIS' && child.membership !== 'TBD') && child.attendanceNo === 0 && child.validated === false) ? 'pulsating-border-alabala border-dottedP' :
                                  (child.paymentStatus === 'TBD' && child.validated === true) ? 'pulsating-border-alabala border-dottedP' :
                                    (child.paymentStatus !== 'TBD' && child.attendanceNo === 0 && child.membership !== 'GRATIS') ? 'pulsating-borderzero border-danger border' :
                                      (child.paymentStatus !== 'TBD' && child.attendanceNo === 1 && child.membership !== 'GRATIS') ? 'pulsating-bordergrench border-warning border' :
                                        (child.paymentStatus !== 'PARTIAL' && child.paymentStatus !== 'TBD' && rescheduleEffect(child, 2)) ? rescheduleEffect(child, 2) :
                                          'border'}
                        `}
                      onClick={() => {
                        if (!isFilterLoading) {
                          setSelectedChildId(child._id);
                          window.localStorage.setItem('selectedChildId', child._id);
                          handleChildPageButtonClick();
                        }
                      }}
                    >
                      {/* Warning yellow icon if first attendance was long ago */}
                      {childFirstAttendance(child) >= 27 && (
                        <img
                          src={childFirstAttendance(child) < 30 ? WarnIconYellow : WarnIconRed}
                          alt="warning"
                          className="warning-icon"
                        />
                      )}

                      {/* Transfer icon if child has a failed assignment */}
                      {Object.values(child.assignments).some((assignment) => assignment.status === 'ESUAT') && (
                        <img
                          src={IconTransfer}
                          alt="transfer"
                          className="transfer-icon"
                        />
                      )}

                      <p style={{ color: getClassByMembership(child.membership), fontSize: "20px", textDecoration: rescheduleEffect(child, 1) }} className='mb-0'>
                        {child.name}
                      </p>

                      {child.attendance.find((att) => { return (new Date(att.date).setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0) && att.status === "PRESENT") }) &&
                        <img alt="check" src={check} className='h-25 check-attendance' />
                      }
                      {child.attendance.find((att) => { return (new Date(att.date).setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0) && att.status === "MISSED") }) &&
                        <img alt="absent" src={absent} className='h-25 check-attendance' />
                      }

                      {/* If selected invalid children and is TBD, show warning icon */}
                      {showInvalid && isTbdChild(child) && (
                        <img
                          src={WarnIconYellow}
                          alt="warning"
                          className="warning-icon position-absolute"
                          style={{ width: "20px", height: "20px", top: "5px", right: "5px" }}
                        />
                      )}

                      {child.assignments && (
                        <p className='text-white m-0 position-absolute fixed-bottom' style={{ fontSize: "12px" }}>
                          {splitGroupAndTimes(child.group, child.time).map((groupTime, index) => {

                            if (child.assignments[`${groupTime.group}-${groupTime.time}`]) {
                              return (
                                <p key={index} className="m-0">
                                  {groupTime.group}-{groupTime.time} -{'>'}
                                  {child.assignments[`${groupTime.group}-${groupTime.time}`].userName}
                                </p>
                              )
                            } else {

                              return null;
                            }
                          })}
                        </p>
                      )}

                      {/* Meeted with Mitzu icon in the right bottom corner */}
                      {(userType === "OWNER" || userType === "ADMIN") && (
                        <img
                          src={
                            // If the date is less than 30 days ago, show green icon
                            isDateLessThan30DaysAgo(child.meetWithMitzu) ? PrezentaConfirm : PrezentaInfirm
                          }
                          alt="warning"
                          className="warning-icon position-absolute"
                          style={{ width: "60px", height: "30px", bottom: "0.5rem", right: "0.2rem" }}
                        />
                      )}

                      {/* Centura icon in the right top corner */}
                      {child.centura && (
                        <img
                          src={centuraIcon}
                          alt="Centura"
                          className="centura-icon position-absolute"
                          style={{ width: "45px", height: "45px", bottom: "0", left: "0" }}
                        />
                      )}

                      {/* Show gift level image if child has a missed gift */}
                      {(userType === "OWNER" || userType === "ADMIN") && typeof child.rank === 'number' && typeof child.giftGiven === 'number' && (child.rank - 1 !== child.giftGiven) && child.giftGiven >= 0 && child.giftGiven < 7 && (
                        <img
                          src={getGiftImage(child.giftGiven)}
                          alt={`Gift Level ${child.giftGiven + 1}`}
                          className="position-absolute"
                          style={{ width: "40px", height: "40px", top: "5px", left: "5px", zIndex: 2 }}
                        />
                      )}
                    </button>
                  ))}
                </InfiniteScroll>

                {nextCursor === null && !isFilterLoading && (
                  <p className='text-white text-center mt-3'>
                    Nu mai sunt copii de afișat!
                  </p>
                )}
              </div>
            </Col>
          </Row>
        </>
      ) : (
        <ChildPage
          child={selectedChild}
          closeFunc={handleClose}
          updateFunc={handleUpdate}
        />
      )}
    </div>
  );
}

export default SearchChild;